import React, { Component } from 'react'
import { Grid, Header, Icon } from 'semantic-ui-react'

import './DisplayDistance.less'

const initialState = {
    showDistanceDetails: true,
    from: '',
    to: '',
    distance: '',
    duration: ''
};

class DisplayDistance extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
    }

    processDistance = (distance) => {
        this.setState({
            from: distance.sourceAddress,
            to: distance.destinationAddress           
        })

        if(_.includes(Object.keys(distance), 'distance') && !_.isEmpty(distance.distance)){
            this.setState({distance: distance.distance.text})
        }

        if(_.includes(Object.keys(distance), 'duration') && !_.isEmpty(distance.duration)){
            this.setState({duration: distance.duration.text})
        }
    }

    componentDidMount(){
        if(this?.props?.sbr?.postProcessing?.distance && !_.isEmpty(this.props.sbr.postProcessing.distance)){
            this.processDistance(this.props.sbr.postProcessing.distance);
        }
        else{
            this.setState({showDistanceDetails: false});
        }
    }

    createLink = () => {
        const from = this.state.from.replace(' ', '+');
        const to = this.state.to.replace(' ', '+');
        return <a href={`https://www.google.com/maps/dir/${from}/${to}`} target="_blank">View on Google</a>
    }
    render() {
        return (
            <div className="distance-display-container">
                 {this.state.showDistanceDetails && <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <div className="estimate-container">
                                <div className="locations">
                                    <div className="location">
                                        <div className="start-pin pin">A</div>
                                        <div>{this.state.from}</div>
                                    </div>
                                    <div className="location">
                                        <div className="end-pin pin">B</div>
                                        <div>{this.state.to}</div>
                                    </div>
                                    <div className="location">
                                    
                                    </div>    
                                </div>
                                <div className="estimate">
                                    <div className="distance">
                                        <div><Icon name="road"></Icon></div>
                                        <div>{this.state.distance}</div>
                                    </div>
                                    <div className="eta">
                                        <div><Icon name="clock outline"></Icon></div>
                                        <div>{this.state.duration}</div>
                                    </div>
                                    <div className="map-link">
                                    {this.createLink()}
                                    </div>    
                                       
                                </div>    
                                
                            </div>    
                            
                        
                         
                        </Grid.Column>
                        
                    </Grid.Row>
                    

                    {/*!this.state.showDistanceDetails && <Grid.Row>
                            <Grid.Column width={16}>
                                No distance details found.
                            </Grid.Column>
                    </Grid.Row>*/}
                </Grid> }
            </div>
        )
    }
}

export default DisplayDistance
